import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { environment } from "../../../environments/environment";
import { DocumentResult } from "../../models/document-result";
import { Registration } from "../../models/registration";
import { DocumentResultControllerService } from "../../services/result-controller/document-result-controller.service";
import { ResultService } from "../../services/result-controller/result.service";
import { RequirementControllerService } from "../../services/requirement-controller/requirement-controller.service";
import { Store } from "../../services/store.service";
import { BaseError } from "../pages/base-error";
import {TranslatedBaseError} from "../pages/TranslatedBaseError";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "document-result-edit",
  templateUrl: "./document-result-edit.component.html",
})
export class DocumentResultEditComponent extends TranslatedBaseError implements OnInit {
  @Input() public serviceId: string;
  @Input() public registration: Registration;
  @Input() public documentResult: DocumentResult = new DocumentResult();
  @Output() public formSubmit = new EventEmitter();
  @Output() public editCancel = new EventEmitter();

  public baseUrl = environment.BASE_URL;
  public subscription: any;
  public isLoading: boolean = false;
  public name: any;

  constructor(public toastr: ToastrService,
              private documentResultControllerService: DocumentResultControllerService,
              private requirementService: RequirementControllerService,
              private resultService: ResultService,
              public store: Store,
              public translateService: TranslateService) {
    super(toastr, translateService);
  }

  public ngOnInit() {
    this.subscription = this.resultService.editData.subscribe((data) => {
      this.serviceId = data.serviceId;
      this.registration = data.registration;
      this.documentResult = data.documentResult;
    });
  }

  public save() {
    if (!this.isLoading) {
      this.isLoading = true;
      if (this.documentResult.id === undefined) {
        this.createDocumentResult(this.documentResult);
      } else {
        this.saveDocumentResult(this.documentResult);
      }
    }
  }

  public createDocumentResult(documentResult: DocumentResult) {
    const requirement = documentResult.requirement;
    requirement.name = documentResult.name;
    this.requirementService.createRequirement(requirement).subscribe(
      (data) => {
        this.formSubmit.emit({ create: true });
        this.responseSuccessful("Result added!");
      },
      (error) => this.showErrorMessage(error),
      () => this.isLoading = false,
    );
  }

  public saveDocumentResult(documentResult: DocumentResult) {
    documentResult.requirement.name = this.documentResult.name;
    documentResult.requirementId = this.documentResult.requirement.id;
    this.requirementService.saveRequirement(documentResult.requirement).subscribe(
      () => {
        this.responseSuccessful("Result updated");
        this.resultService.updateData();
        this.formSubmit.emit({ save: true });
      },
      (error) => this.showErrorMessage(error),
      () => this.isLoading = false,
    );
  }

  public deleteDocumentResult(isConfirmed: boolean) {
    if (isConfirmed) {
      this.documentResultControllerService.deleteRegistrationResult(this.documentResult.id).subscribe(
        (data) => {
          this.formSubmit.emit({ save: false, delete: true, documentResult: undefined });
          this.responseSuccessful("Data is deleted!");
        },
        (error) => this.showErrorMessageWithTitle("Result delete error! ", error),
      );
    }
  }

  public cancel() {
    this.editCancel.emit({
      save: false, cancel: true,
    });
  }

}
